import React from 'react'
import Footer from './Footer';
import Serv1 from './Pages/Img/k2.png';
import Serv2 from './Pages/Img/k3.png';
import Serv3 from './Pages/Img/k1.png';



const Service = () => {
    return (
        <>

            <div className='Service'>

                <div className='Serve'>
                    <img src={Serv1} />
                </div>

                <div className='Serve'>
                    <h1>Catering</h1>
                    <p>We are the Well Know Name in Catering  Service </p>
                    <a href=''>  <button>Book Now </button></a>
                </div>

            </div>



            <div className='Service'>


                <div className='Serve'>
                    <h1>Baverage Cafeteria </h1>
                    <p>We are the best in mocktail</p>
                    <a href=''>  <button>Book Now </button></a>
                </div>


                <div className='Serve'>
                    <img src={Serv2} />
                </div>



            </div>

            <div className='Service'>

                <div className='Serve'>
                    <img src={Serv3} />
                </div>

                <div className='Serve'>
                    <h1>Cocktails</h1>
                    <p>We have a huge variety of cocktail  </p>
                    <a href=''>  <button>Book Now </button></a>
                </div>

            </div>


            <Footer />
        </>
    )
}

export default Service